import { Title } from "@appquality/appquality-design-system";
import { PlaceholderText, Section } from "../styled";
import { MarkdownEditor } from "./MarkdownEditor";

interface Props {
  title: string;
  isEditing: boolean;
  value: string;
  emptyPlaceholder?: string;
  onChange: (value: string) => void;
}

const BugTextSection = ({
  title,
  isEditing,
  value,
  emptyPlaceholder,
  onChange,
}: Props) => {
  return (
    <Section>
      <Title size="s" className="aq-mb-2">
        {title}
      </Title>
      {!isEditing && !value ? (
        <PlaceholderText>{emptyPlaceholder || "—"}</PlaceholderText>
      ) : (
        <MarkdownEditor
          key={isEditing ? "editing" : "viewing"}
          initialValue={value}
          onChange={onChange}
          editable={isEditing}
        />
      )}
    </Section>
  );
};

export default BugTextSection;
